import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-company-menu',
  templateUrl: './company-menu.component.html',
  styleUrls: ['./company-menu.component.styl']
})
export class CompanyMenuComponent implements OnInit {
  constructor(
    public sql: SQLService,
    public popover: PopoverController,
    private router: Router) {
  }
  list:string;
  @Input('selected') selected:boolean;
  dismissPopover(e) {
    if (this.popover) this.popover.dismiss(e);
  }
  delete() {
    this.dismissPopover('delete');
  }
  select() {
    this.dismissPopover('select');
  }
  end(){
    this.dismissPopover(null);
  }
  ngOnInit() {
  }
}